import React from 'react';
import './loadingScreen.css';

const HashelyMark = ({ size = 44 }) => {
  const uid = React.useId().replace(/:/g, '');
  const gradientId = `hashelyLoaderHash-${uid}`;

  return (
    <svg
      className="hashely-loader-hash"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} gradientUnits="userSpaceOnUse" x1="8" y1="56" x2="56" y2="8">
          <stop offset="0%" stopColor="#1e1b4b" />
          <stop offset="38%" stopColor="#2563eb" />
          <stop offset="72%" stopColor="#0d9488" />
          <stop offset="100%" stopColor="#5eead4" />
        </linearGradient>
      </defs>
      <g fill={`url(#${gradientId})`}>
        <rect x="16.5" y="6" width="12" height="52" rx="6" transform="rotate(-7 22.5 32)" />
        <rect x="35.5" y="6" width="12" height="52" rx="6" transform="rotate(-7 41.5 32)" />
        <rect x="6" y="18" width="52" height="12" rx="6" />
        <rect x="6" y="34" width="52" height="12" rx="6" />
      </g>
    </svg>
  );
};

const LoadingScreen = ({
  fullScreen = true,
  compact = false,
  message,
}) => {
  const label =
    message === undefined
      ? compact
        ? 'Loading'
        : 'Loading your workspace'
      : message;

  return (
    <div
      className={[
        'hashely-loader',
        fullScreen ? 'hashely-loader--screen' : 'hashely-loader--embed',
        compact ? 'hashely-loader--compact' : '',
      ]
        .filter(Boolean)
        .join(' ')}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label || 'Loading'}
    >
      <div className="hashely-loader-orb" aria-hidden="true" />
      <div className="hashely-loader-orb hashely-loader-orb--teal" aria-hidden="true" />
      <div className="hashely-loader-stack">
        <div className="hashely-loader-mark">
          <span className="hashely-loader-ring" aria-hidden="true" />
          <HashelyMark size={compact ? 36 : 48} />
        </div>
        {compact ? null : <p className="hashely-loader-wordmark">Hashely</p>}
        {label ? <p className="hashely-loader-message">{label}</p> : null}
        <div className="hashely-loader-dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
